import request from '../utils/request'

export default {
  get: async (key, setKeyValue, defaultValue = 0) => {
    if (!key) return
    const res = await request.get('/backend-api/sso-api/common/setting/get', { params: { key } })
    setKeyValue(res ? Number(res) : defaultValue)
  },
  set: (key, value) => {
    request.get(`/backend-api/sso-api/common/setting/set?key=${key}&value=${value}`)
  },
  toGet: async (key) => {
    if (!key) return
    const res = await request.get('/backend-api/sso-api/common/setting/get', { params: { key } })
    return res
  },
  toSetObj: async (key, values = {}) => {
    const _values = encodeURIComponent(JSON.stringify(values))
    await request.get(`/backend-api/sso-api/common/setting/set?key=${key}&value=${_values}`)
  },
  toGetObj: async (key) => {
    const res = await request.get('/backend-api/sso-api/common/setting/get', { params: { key } })
    return res && JSON.parse(decodeURIComponent(res))
  },
}
